// GalleryDataGrid.jsx

import React from 'react';

// CSS
import './GalleryDataGrid.css';

// Components
import Grid from 'node/grid/Grid';

/**
 * GalleryDataGrid
 *
 * @returns {ReactNode} The rendered component.
 */
const GalleryDataGrid = React.memo(({
    containerRef,
    displayedNodes,
    gap,
    minCols,
    maxCols,
    colWidth,
    theme,
    handleCardClick,
    handleCardDoubleClick,
    handleCardDragStart = null,
    renderDataCard,
    renderCardOverlay,
    hasMore,
    loadMoreRef,
}) => {

  // ----- RENDER ----- //

  return (
        <div className="gallery-view-container" ref={containerRef}>
            <Grid
                items={displayedNodes}
                gap={`${gap}px`}
                minCols={minCols}
                maxCols={maxCols}
                colWidth={colWidth}
                renderItem={(item) => (
                    <div
                        className="gallery-view-card gallery-view-card--data"
                      key={item?.key}
                      draggable={Boolean(handleCardDragStart && item?.key)}
                      onDragStart={handleCardDragStart
                        ? (event) => handleCardDragStart(event, item)
                        : undefined}
                      onClick={(event) => handleCardClick(event, item)}
                      onDoubleClick={(event) => handleCardDoubleClick(event, item)}
                    >
                        {renderCardOverlay?.(item)}
                        {renderDataCard(item)}
                    </div>
                )}
            />
            {hasMore && (
                <div className="gallery-view-load-more" ref={loadMoreRef} />
            )}
        </div>
    );
});

// Dev Tools
GalleryDataGrid.displayName = 'GalleryDataGrid';

export default GalleryDataGrid;
